import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "tw-p-2" }
const _hoisted_2 = {
  key: 0,
  class: "tw-text-sm tw-text-slate-500 tw-mb-4"
}
const _hoisted_3 = { class: "tw-mb-4 tw-flex tw-items-center" }
const _hoisted_4 = { class: "tw-inline-flex tw-items-center tw-gap-2 tw-text-sm tw-font-medium tw-text-slate-700 tw-cursor-pointer" }
const _hoisted_5 = { class: "tw-overflow-hidden tw-rounded-xl tw-border tw-border-slate-200 tw-bg-white" }
const _hoisted_6 = { class: "tw-w-full tw-border-collapse tw-text-left tw-text-sm" }
const _hoisted_7 = {
  key: 0,
  class: "tw-divide-y tw-divide-slate-100"
}
const _hoisted_8 = { class: "tw-px-4 tw-py-3 tw-font-medium tw-text-slate-900" }
const _hoisted_9 = { class: "tw-px-4 tw-py-3" }
const _hoisted_10 = {
  key: 0,
  class: "tw-inline-flex tw-items-center tw-rounded-md tw-bg-emerald-50 tw-px-2 tw-py-1 tw-text-xs tw-font-medium tw-text-emerald-700 tw-ring-1 tw-ring-inset tw-ring-emerald-600/20"
}
const _hoisted_11 = {
  key: 1,
  class: "tw-inline-flex tw-items-center tw-rounded-md tw-bg-slate-100 tw-px-2 tw-py-1 tw-text-xs tw-font-medium tw-text-slate-600"
}
const _hoisted_12 = { class: "tw-px-4 tw-py-3" }
const _hoisted_13 = {
  key: 1,
  class: "tw-mt-4 tw-flex tw-justify-center"
}
const _hoisted_14 = { class: "tw-overflow-hidden tw-rounded-xl tw-border tw-border-slate-200 tw-bg-white" }
const _hoisted_15 = { class: "tw-w-full tw-border-collapse tw-text-left tw-text-sm" }
const _hoisted_16 = {
  key: 0,
  class: "tw-divide-y tw-divide-slate-100"
}
const _hoisted_17 = ["onClick"]
const _hoisted_18 = { class: "tw-px-4 tw-py-3 tw-font-bold tw-text-slate-900" }
const _hoisted_19 = { class: "tw-px-4 tw-py-3 tw-text-slate-600" }
const _hoisted_20 = { key: 0 }
const _hoisted_21 = {
  key: 1,
  class: "tw-italic tw-text-slate-400"
}
const _hoisted_22 = { class: "tw-px-4 tw-py-3 tw-text-slate-600" }
const _hoisted_23 = { class: "tw-px-4 tw-py-3" }
const _hoisted_24 = { key: 0 }
const _hoisted_25 = {
  key: 2,
  class: "tw-mt-4 tw-flex tw-justify-center"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_YardStatusLabel = _resolveComponent("YardStatusLabel")!
  const _component_PaginationBar = _resolveComponent("PaginationBar")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[10] || (_cache[10] = _createElementVNode("h2", { class: "tw-text-xl tw-font-bold tw-tracking-tight tw-text-slate-800 tw-mb-1" }, "Containers", -1)),
    (_ctx.containersData)
      ? (_openBlock(), _createElementBlock("p", _hoisted_2, _toDisplayString(_ctx.containersData.total) + " containers ", 1))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("label", _hoisted_4, [
        _withDirectives(_createElementVNode("input", {
          class: "tw-h-4 tw-w-4 tw-rounded tw-border-slate-300 tw-text-slate-900 focus:tw-ring-slate-900",
          type: "checkbox",
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.showActiveOnly) = $event))
        }, null, 512), [
          [_vModelCheckbox, _ctx.showActiveOnly]
        ]),
        _cache[5] || (_cache[5] = _createTextVNode(" Show Active Only ", -1))
      ])
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("table", _hoisted_6, [
        _cache[6] || (_cache[6] = _createElementVNode("thead", { class: "tw-bg-slate-50 tw-border-b tw-border-slate-200" }, [
          _createElementVNode("tr", null, [
            _createElementVNode("th", { class: "tw-px-4 tw-py-3 tw-font-semibold tw-text-slate-700" }, "Container"),
            _createElementVNode("th", { class: "tw-px-4 tw-py-3 tw-font-semibold tw-text-slate-700" }, "Active Shipment"),
            _createElementVNode("th", { class: "tw-px-4 tw-py-3 tw-font-semibold tw-text-slate-700" }, "Yard Status")
          ])
        ], -1)),
        (_ctx.containersData)
          ? (_openBlock(), _createElementBlock("tbody", _hoisted_7, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.containerList, (container) => {
                return (_openBlock(), _createElementBlock("tr", {
                  key: `customer-container-${container.id}`,
                  class: "hover:tw-bg-slate-50/50"
                }, [
                  _createElementVNode("td", _hoisted_8, _toDisplayString(container.containerId != 'EXPUNDEF' ? container.containerId : 'Container Not Defined'), 1),
                  _createElementVNode("td", _hoisted_9, [
                    (container.isActive)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_10, " Active "))
                      : (_openBlock(), _createElementBlock("span", _hoisted_11, " Archived "))
                  ]),
                  _createElementVNode("td", _hoisted_12, [
                    _createVNode(_component_YardStatusLabel, {
                      container: container,
                      enableStale: false
                    }, null, 8, ["container"])
                  ])
                ]))
              }), 128))
            ]))
          : _createCommentVNode("", true)
      ])
    ]),
    (_ctx.containersData && _ctx.containersData.pages > 1)
      ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
          _createVNode(_component_PaginationBar, {
            page: _ctx.containersPage,
            totalPages: _ctx.containersData.pages,
            onPreviousPage: _cache[1] || (_cache[1] = ($event: any) => (_ctx.updateContainersPage(-1))),
            onNextPage: _cache[2] || (_cache[2] = ($event: any) => (_ctx.updateContainersPage(1))),
            onGoToPage: _ctx.goToContainersPage
          }, null, 8, ["page", "totalPages", "onGoToPage"])
        ]))
      : _createCommentVNode("", true),
    _cache[11] || (_cache[11] = _createElementVNode("div", { class: "tw-my-8 tw-border-t tw-border-slate-100" }, null, -1)),
    _cache[12] || (_cache[12] = _createElementVNode("h2", { class: "tw-text-xl tw-font-bold tw-tracking-tight tw-text-slate-800 tw-mb-4" }, "Orders", -1)),
    _createElementVNode("div", _hoisted_14, [
      _createElementVNode("table", _hoisted_15, [
        _cache[9] || (_cache[9] = _createElementVNode("thead", { class: "tw-bg-slate-50 tw-border-b tw-border-slate-200" }, [
          _createElementVNode("tr", null, [
            _createElementVNode("th", { class: "tw-px-4 tw-py-3 tw-font-semibold tw-text-slate-700" }, "Order #"),
            _createElementVNode("th", { class: "tw-px-4 tw-py-3 tw-font-semibold tw-text-slate-700" }, "Bill of Lading"),
            _createElementVNode("th", { class: "tw-px-4 tw-py-3 tw-font-semibold tw-text-slate-700" }, "# Containers"),
            _createElementVNode("th", { class: "tw-px-4 tw-py-3 tw-font-semibold tw-text-slate-700" }, "Status"),
            _createElementVNode("th", { class: "tw-px-4 tw-py-3" })
          ])
        ], -1)),
        (_ctx.ordersData)
          ? (_openBlock(), _createElementBlock("tbody", _hoisted_16, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.ordersData.orders, (order) => {
                return (_openBlock(), _createElementBlock("tr", {
                  key: order.id,
                  onClick: ($event: any) => (_ctx.selectOrder(order.id)),
                  class: "tw-cursor-pointer hover:tw-bg-slate-50 tw-transition-colors"
                }, [
                  _createElementVNode("td", _hoisted_18, "#" + _toDisplayString(order.id), 1),
                  _createElementVNode("td", _hoisted_19, [
                    (order.billOfLading)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_20, _toDisplayString(order.billOfLading.billOfLadingId), 1))
                      : (_openBlock(), _createElementBlock("span", _hoisted_21, _toDisplayString(order.bookingNumber || 'No B/L'), 1))
                  ]),
                  _createElementVNode("td", _hoisted_22, _toDisplayString(order.containers ? order.containers.length : 0), 1),
                  _createElementVNode("td", _hoisted_23, [
                    _createElementVNode("span", {
                      class: _normalizeClass(["tw-inline-flex tw-items-center tw-rounded-md tw-px-2 tw-py-1 tw-text-xs tw-font-medium", order.status === 'Complete' ? 'tw-bg-emerald-50 tw-text-emerald-700 tw-ring-1 tw-ring-inset tw-ring-emerald-600/20' : 'tw-bg-blue-50 tw-text-blue-700 tw-ring-1 tw-ring-inset tw-ring-blue-600/20'])
                    }, _toDisplayString(order.status), 3)
                  ]),
                  _cache[7] || (_cache[7] = _createElementVNode("td", { class: "tw-px-4 tw-py-3 tw-text-right" }, [
                    _createElementVNode("button", { class: "tw-rounded-lg tw-bg-slate-800 tw-px-3 tw-py-1.5 tw-text-xs tw-font-semibold tw-text-white hover:tw-bg-slate-700 tw-transition-colors" }, " Go to order ")
                  ], -1))
                ], 8, _hoisted_17))
              }), 128)),
              (_ctx.$apollo.queries.ordersData.loading)
                ? (_openBlock(), _createElementBlock("tr", _hoisted_24, [...(_cache[8] || (_cache[8] = [
                    _createElementVNode("td", {
                      colspan: "5",
                      class: "tw-px-4 tw-py-8 tw-text-center"
                    }, [
                      _createElementVNode("div", { class: "tw-inline-block tw-h-6 tw-w-6 tw-animate-spin tw-rounded-full tw-border-2 tw-border-solid tw-border-slate-900 tw-border-r-transparent" })
                    ], -1)
                  ]))]))
                : _createCommentVNode("", true)
            ]))
          : _createCommentVNode("", true)
      ])
    ]),
    (_ctx.ordersData && _ctx.ordersData.pages > 1)
      ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
          _createVNode(_component_PaginationBar, {
            page: _ctx.ordersPage,
            totalPages: _ctx.ordersData.pages,
            onPreviousPage: _cache[3] || (_cache[3] = ($event: any) => (_ctx.updateOrdersPage(-1))),
            onNextPage: _cache[4] || (_cache[4] = ($event: any) => (_ctx.updateOrdersPage(1))),
            onGoToPage: _ctx.goToOrdersPage
          }, null, 8, ["page", "totalPages", "onGoToPage"])
        ]))
      : _createCommentVNode("", true)
  ]))
}